import React from 'react';
import FadeIn from 'react-fade-in';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useTranslation } from 'react-i18next';
import ClientTabs from './ClientTabs';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  preloaderCard: {
    height: '82vh'
  }
}));

const ClientDetailView = () => {
  const { classes } = useStyles();

  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={`${t('COMMON.CLIENT')} `}>
      <FadeIn transitionDuration={300}>
        <Container maxWidth={false}>
          <Box>
            <ClientTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default ClientDetailView;
